import { hasProp } from "../../helpers/Class";
import i18n from "../../i18n";
import {formatPrice} from "../../helpers/Billing";
import DistributionAddress from "./DistributionAddress";

class WithdrawalPoint {
    constructor(withdrawalPoint = null) {
        this._id = !hasProp(withdrawalPoint, "_id") ? undefined : withdrawalPoint._id;
        this.name = !hasProp(withdrawalPoint, "name") ? undefined : withdrawalPoint.name;
        this.address = !hasProp(withdrawalPoint, "address") ? new DistributionAddress() : new DistributionAddress(withdrawalPoint.address);
        this.currency = !hasProp(withdrawalPoint, "currency") ? undefined : withdrawalPoint.currency;
        this.priceWT = !hasProp(withdrawalPoint, "priceWT") ? undefined : withdrawalPoint.priceWT;
        this.chargedBy = !hasProp(withdrawalPoint, "chargedBy") ? undefined : withdrawalPoint.chargedBy;
    }

    get addressLabel() {
        return this.address.addressLabel;
    }

    getChargedByLabel(currencies) {
        return `${formatPrice(this.priceWT, this.currency, currencies)} ${i18n.t(`class.WithdrawalPoint.chargedBy.${this.chargedBy}`)}`;
    }
}

export default WithdrawalPoint;